<template>
   <div class="div18 cutbox" :style="`background:url(${info.image}) no-repeat;background-size: 100% 100%;`">
      <div class="center-block" v-if="info.index==0">
            <div class="text1" data-id="主标题1" data-range="5,8">
                {{ info.titles[1] }}
            </div>
            <div class="text2" data-id="副标题1" data-range="9,12">
                 {{ info.titles[0] }}
            </div>
         </div>
   </div>
</template>
<script>
export default {
   name: 'TUWEN018',
   props: {
      info: Object
   },
}
</script>
